import moment from 'moment'
import { useState } from 'react'

const useHandleDateRangePicker = (timePickerDefault) => {
    const [ timePicker, setTimePicker] = useState(() => {
        return {
            startDate: timePickerDefault?.startDate || moment().startOf('day').toDate(),
            endDate: timePickerDefault?.endDate || moment().endOf('day').toDate()
        }
    })

    return {
        timePicker, 
        setTimePicker
    }
}

export default useHandleDateRangePicker